import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/OnboardAssessmentLogDetails/api/onboardAssessmentLogDetailsService'
import { OnboardAssessmentLogDetailsState, ApiOnboardAssessmentLogDetailsResponse } from './types'

const initialState: OnboardAssessmentLogDetailsState = {
  data: {},
}

const onboardAssessmentLogDetailsSlice = createSlice({
  name: 'activityLogOnboardAssessmentLogDetails',
  initialState,
  reducers: {
    dataLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiOnboardAssessmentLogDetailsResponse>>
    ) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = onboardAssessmentLogDetailsSlice.actions

export default onboardAssessmentLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
